import { EmpresaFilters } from "../../types/empresa";
import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from "react";
import { useGetFrecuenciaFilterDataQuery } from "../../api/filter/dataFilterApi";
import { useSelector } from "react-redux";
import { selectCurrentUserRole } from "../../api/auth/authSlice";
import { AvailableEmpresaFilters } from "../../utils/enums";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

interface Props {
    filters: EmpresaFilters;
    setFilters: Dispatch<SetStateAction<EmpresaFilters>>;
}

export function Filters({ filters, setFilters }: Props) {
    const [searchValue, setSearchValue] = useState<string | null>(null);
    const userRole = useSelector(selectCurrentUserRole);

    const queryParams: AvailableEmpresaFilters[] = [
        AvailableEmpresaFilters.Frecuencias,
    ];

    if(userRole == "Administrador")
        queryParams.push(AvailableEmpresaFilters.Prospectadores);

    const { data: filterValues } = useGetFrecuenciaFilterDataQuery(queryParams);

    const onFilterChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFilters({
            ...filters,
            [event.target.name]: event.target.value
        });
    }

    useEffect(() => {
        if(searchValue == null) return;

        setFilters({
            ...filters,
            nombre: searchValue,
        });

    }, [searchValue]);

    return (
    <div className="flex flex-col gap-y-2 my-1">
        <div className="border-0 border-green-500 w-full mx-2 h-auto flex grow-0 items-center gap-x-1 justify-">
            <SearchRoundedIcon sx={{ height: 25, width: 25 }}/>
            <input 
                className="border-gray-300 border-2 rounded text-gray-600 w-11/12 px-3"
                placeholder="Buscar empresa..."
                autoComplete="off"
                onChange={(event) => setSearchValue(event.target.value)}
                name="nombre"
                type="text" />
        </div>
        <div className="border-0 border-green-500 w-fit mx-2 h-auto flex grow-0 items-center gap-x-3 justify-end">
            <input 
                className="border-gray-300 border-2 rounded text-gray-600 text-center"
                onChange={onFilterChange}
                name="fechaInicio"
                type="date" />
            <input 
                className="border-gray-300 border-2 rounded text-gray-600 text-center"
                onChange={onFilterChange}
                name="fechaFin"
                type="date" />

            <label className="font-semibold text-gray-600 text-sm">Estado: </label>
            <select 
                onChange={onFilterChange}
                className="border-2 border-gray-300 rounded text-sm font-semibold text-gray-600"
                name="estado">
                <option hidden value="">Seleccionar estado</option>
                <option value="">Todos los estados</option>
                <option value="Activa">Activa</option>
                <option value="Inactiva">Inactiva</option>
                <option value="Nueva">Nueva</option>
            </select>

            <label className="font-semibold text-gray-600 text-sm">Frecuencia de visita: </label>
            <select 
                onChange={onFilterChange}
                className="border-2 border-gray-300 rounded text-sm font-semibold text-gray-600"
                name="frecuenciaVisita">
                <option hidden value="">Seleccionar frecuencia</option>
                <option value="">Todas las frecuencias</option>
                {filterValues?.frecuencia.map((frecuencias, index) => (
                <option value={frecuencias} key={index}>{frecuencias}</option>
                ))}
            </select>

            {userRole === "Administrador" && (<>
            <label className="font-semibold text-gray-600 text-sm">Prospectador: </label>
            <select 
                onChange={onFilterChange}
                className="border-2 border-gray-300 rounded text-sm font-semibold text-gray-600"
                name="prospectador">
                <option hidden value="">Seleccionar prospectador</option>
                <option value="">Todas los prospectadores</option>
                {filterValues?.prospectadores.map((prospectador, index) => (
                <option value={prospectador.id} key={index}>{prospectador.nombre}</option>
                ))}
            </select>
            </>)}
        </div>

    </div>
    );
}